module.exports = __webpack_public_path__ + "static/img/logo-white.5009abe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-white.svg
// module id = OokW
// module chunks = 3